
import { collection, addDoc, serverTimestamp, query, where, orderBy, onSnapshot, doc, deleteDoc, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';
import { SavedPlan } from '../types';

export const saveAIPlan = async (userId: string, type: 'workout' | 'diet', title: string, content: any) => {
  const plansRef = collection(db, "users", userId, "savedPlans");
  const docRef = await addDoc(plansRef, {
    userId,
    type,
    title,
    content,
    createdAt: serverTimestamp()
  });
  return docRef.id;
};

export const deleteAIPlan = async (userId: string, planId: string) => {
  const planRef = doc(db, "users", userId, "savedPlans", planId);
  await deleteDoc(planRef);
};

export const subscribeToUserPlans = (userId: string, callback: (plans: SavedPlan[]) => void) => {
  // 🔒 CRITICAL FIX: Verify userId === auth.currentUser.uid BEFORE creating listener
  const currentUid = auth.currentUser?.uid;
  if (!currentUid || currentUid !== userId) {
    // ❌ NOT your plans → no snapshot, return empty
    if (import.meta.env.DEV) {
      console.warn('[PLANS] subscribeToUserPlans blocked: userId !== currentUser.uid');
    }
    try {
      callback([]);
    } catch {
      // Silently ignore callback errors
    }
    return () => {};
  }

  const q = query(
    collection(db, "users", userId, "savedPlans"),
    orderBy("createdAt", "desc")
  );
  
  return onSnapshot(q, (snap) => {
    const plans = snap.docs.map(d => ({ id: d.id, ...d.data() } as SavedPlan));
    callback(plans);
  }, (error) => {
    // Handle errors gracefully
    if (import.meta.env.DEV && error?.code !== 'permission-denied') {
      console.warn('[PLANS] Error in subscribeToUserPlans:', error?.code, error?.message);
    }
    try {
      callback([]);
    } catch {
      // Silently ignore
    }
  });
};
